"use client";

import { useMemo } from "react";
import { IAirdropTaskRender } from "@/types/task-renderer.types";
import { getAirdropArgumentValue } from "@/lib/challenges";
import { QuestTaskButton } from "../QuestTaskButton";
import Image from "next/image";

export const DiscordRoleRenderer = ({
  task,
  completeTaskMutation,
  campaign,
}: IAirdropTaskRender) => {
  const taskConfig = useMemo(() => {
    const campaignTask = campaign?.tasks?.find((t) => t.id === task.taskGuid);
    if (!campaignTask) return null;
    
    const serverId = getAirdropArgumentValue(campaignTask.arguments, "serverId");
    const roleName = getAirdropArgumentValue(campaignTask.arguments, "roleName");
    
    return {
      serverId,
      roleName,
    };
  }, [campaign, task]);

  const buttonName = useMemo(() => {
    if (task.status === "SUCCESSFUL") {
      return "Role Claimed";
    }
    return "Claim Role";
  }, [task.status]);

  return (
    <div className="space-y-4">
      {/* Discord Role Info */}
      <div className="bg-gray-800/30 rounded-lg p-4 border border-gray-700/50">
        <div className="flex items-center gap-3 mb-3">
          <Image
            src="https://pulsarmoney.b-cdn.net/rhuna/discord_icon_new.png"
            alt="Discord"
            width={24}
            height={24}
            className="w-6 h-6"
          />
          <h3 className="text-white font-medium">Discord Role Required</h3>
        </div>
        
        {taskConfig?.roleName && (
          <div className="space-y-2">
            <p className="text-gray-300 text-sm">
              You need to have the <span className="text-[#60FF8A] font-medium">&ldquo;{taskConfig.roleName}&rdquo;</span> role in our Discord server.
            </p>
            <p className="text-gray-400 text-xs">
              Make sure you&apos;re connected to Discord and have the required role assigned.
            </p>
          </div>
        )}
      </div>

      {/* Claim Button */}
      <div className="flex justify-center">
        <QuestTaskButton
          buttonText={buttonName}
          taskMutation={completeTaskMutation}
          className="w-full sm:w-auto"
          task={task}
          onClick={() => {
            completeTaskMutation.mutateAsync({
              campaignId: campaign.id,
              groupId: campaign.campaignGroup,
              taskName: task.taskName,
              extraArguments: [],
              taskGuid: task.taskGuid,
            });
          }}
        />
      </div>
    </div>
  );
};
